<template>
  <div class="header-container" :style="{'background':headBackground}">
    <div class="l-content">
      <el-button size="small" @click="handleMenu" :icon="isbutton_icon"></el-button>
      <!-- 面包屑 -->
      <el-breadcrumb separator="/">

      </el-breadcrumb>
      <div class="username"> <i class="el-icon-user" translate="no"> {{ username }}</i></div>

      <el-button size="small" type="primary" @click="referCoins" :loading="load" style="width:90%;" translate="no">{{ $t('msg.my_score') }} {{ coins }}</el-button>
    </div>
    <div class="r-content">
      <el-button size="small" type="info" @click="open" style="width:90%;">{{$t('msg.Sign_out')}}<i class="el-icon-d-arrow-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {GetCoins} from "../api";

export default {
  name: "CommonHeader",
  data() {
    return {
      username: localStorage.getItem("username"),
      coins: JSON.parse(localStorage.getItem("userInfo")).coins,
      load: false,
      addload: false,
    }
  },
  methods: {
    handleMenu() {
      this.$store.commit('collapseMenu')
    },
    open() {
      this.$confirm(this.$t('msg.Confirm_Logout'), '', {
        confirmButtonText: this.$t('msg.OK2'),
        cancelButtonText: this.$t('msg.Cancel'),
        type: 'warning',
        customClass:'alert',//添加类名
        center: true,
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('username')
        localStorage.removeItem('proxy_id')
        this.$message({
          type: 'success',
          message: this.$t('msg.Logged_out')
        });
        this.$router.push({name: 'login'})
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // });
      });
    },
    referCoins() {
      this.load = true
      const startTime = Date.now()
      const done = () => {
        const elapsed = Date.now() - startTime
        setTimeout(() => { this.load = false }, Math.max(0, 300 - elapsed))
      }
      GetCoins({}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          var userInfo = JSON.parse(localStorage.getItem('userInfo'))
          userInfo['coins'] = data.data.params.coins
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          this.coins = data.data.params.coins
        }
        done()
      }).catch(done)
    },
  },
  computed: {
    isbutton_icon() {
      return this.$store.state.tab.button_icon
    },
    ...mapState({
      tags: state => state.tab.tabsListCrumbs
    }),
    headBackground(){
      return '#374151'
    }
  },
  mounted() {
    const that=this
    window.addEventListener('setItemEvent', function (e) {
      if (e.key === 'userInfo') {
        that.mykey = e.newValue;
        that.coins = JSON.parse(e.newValue).coins
      }
    })
  }
}
</script>

<style lang="less">
.header-container {
  padding: 0 10px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  overflow: auto;
  position: relative;
  z-index: 9999;
  &::-webkit-scrollbar {
    display: none;
  }
  .username{
    white-space: nowrap;
    margin: 0 10px;
  }

  .text {
    color: #fff;
    font-size: 14px;
    margin-left: 10px;
  }

  .r-content {
    flex-shrink: 0;
    margin-left: 10px;
    .user {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .l-content {
    flex-shrink: 0;
    display: flex;
    align-items: center;

    /deep/ .el-breadcrumb__item {
      .el-breadcrumb__inner {
        color: #b6e5f3;
      }
    }

  }
}

/* 使用媒体查询来调整样式 */
@media screen and (max-width: 500px) {
  .alert{
    width: 240px;
  }

}

</style>



// WEBPACK FOOTER //
// src/components/CommonHeader.vue